import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';  // Import PropTypes explicitly
import { Layout, Box, Divider } from '@shopify/polaris';

const AboutThisApp = ({ appData }) => {
  const [expanded, setExpanded] = useState({});

  const originalDate = appData && appData.created_at ? new Date(appData.created_at) : null;
  const [isTabletView, setIsTabletView] = useState<boolean>(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsTabletView(window.innerWidth <= 1024); // Example: Consider width <= 1024 as tablet view
    };

    // Call checkScreenSize once to determine initial view
    checkScreenSize();

    // Add event listener to check screen size on resize
    window.addEventListener('resize', checkScreenSize);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);
  const formattedDate = originalDate
    ? originalDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
    : new Date().toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  useEffect(() => {
    // Your useEffect logic goes here
  }, []);

  return (



    <>
      <div>
        {isTabletView ? (
          <>

            <div className='container'>
              <div style={{ paddingTop: "50px", }} className="container" >
                <p className="" style={{ fontFamily: "sfprobold", fontSize: "25px", color: '#0B0757' }}>About this app</p>
              </div>
              <div style={{ paddingTop: "" }}>
                <p className="title" style={{ fontFamily: "sfpromedium", fontSize: "16px" }}>Launched</p>
                <p className="value" style={{ fontFamily: "sfproregular", fontSize: "16px", paddingTop: '5px' }}>{formattedDate}</p>

              </div>
              <div style={{ paddingTop: "20px" }}>
                <p className="title" style={{ fontFamily: "sfpromedium", fontSize: "16px", }}>Languages</p>
                <p className="value" style={{ fontFamily: "sfproregular", fontSize: "16px", paddingTop: '10px' }}>English</p>

              </div>
              <div style={{ paddingTop: "20px" }}>
                <p className="title" style={{ fontFamily: "sfpromedium", fontSize: "16px" }}>Categories</p>
                <p className="value" style={{ fontFamily: "sfproregular", fontSize: "16px", paddingTop: '10px' }}>
                  {appData.list_of_categories.map(category => capitalizeFirstLetter(category.name)).join(', ')}
                </p>
              </div>
            </div>




          </>
        ) : (
          <>
            <div className="hidden md:block">
              <div style={{ paddingTop: "50px" }} className="container">
                <p className="" style={{ fontFamily: "sfprobold", fontSize: "25px", color: '#0B0757' }}>About this app</p>

                <div className="flex flex-col md:flex-row" style={{ paddingTop: '20px', gap: "50px", width: " max-content" }}> {/* Removed justify-between */}
                  <div className="container flex flex-col items-start md:items-start"> {/* Adjusted alignment */}
                    <p className="title" style={{ fontFamily: "sfproregular", fontSize: "16px" }}>Launched</p>
                    <p className="value" style={{ fontFamily: "sfproregular", fontSize: "16px", paddingTop: '10px' }}>{formattedDate}</p>
                  </div>
                  <div className="divider md:hidden" style={{ margin: 'auto 10px' }}></div> {/* Vertical divider, hidden on medium screens and above */}
                  <div className="divider hidden md:block" style={{ margin: 'auto 10px', height: '60px', backgroundColor: '#D3D3D3' }}></div> {/* Vertical divider, visible on medium screens and above */}

                  <div className="container flex flex-col items-start md:items-start"> {/* Adjusted alignment */}
                    <p className="title" style={{ fontFamily: "sfproregular", fontSize: "16px", }}>Languages</p>
                    <p className="value" style={{ fontFamily: "sfproregular", fontSize: "16px", paddingTop: '10px' }}>English</p>
                  </div>
                  <div className="divider md:hidden" style={{ margin: 'auto 10px' }}></div> {/* Vertical divider, hidden on medium screens and above */}
                  <div className="divider hidden md:block" style={{ margin: 'auto 10px', height: '60px', backgroundColor: '#D3D3D3' }}></div> {/* Vertical divider, visible on medium screens and above */}

                  <div className="container flex flex-col items-start md:items-start"> {/* Adjusted alignment */}
                    <p className="title" style={{ fontFamily: "sfproregular", fontSize: "16px" }}>Categories</p>
                    <p className="value" style={{ fontFamily: "sfproregular", fontSize: "16px", paddingTop: '10px' }}>
                      {appData.list_of_categories.map(category => capitalizeFirstLetter(category.name)).join(', ')}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Second div - Show on mobile view */}
            <div className="block md:hidden">
              <div style={{ paddingTop: "50px", }} className="container" >


                <p className="" style={{ fontFamily: "sfprobold", fontSize: "25px", color: '#0B0757' }}>About this app</p>



              </div>
              <div style={{ paddingTop: "" }}>
                <p className="title" style={{ fontFamily: "sfpromedium", fontSize: "16px" }}>Launched</p>
                <p className="value" style={{ fontFamily: "sfproregular", fontSize: "16px", paddingTop: '5px' }}>{formattedDate}</p>

              </div>
              <div style={{ paddingTop: "20px" }}>
                <p className="title" style={{ fontFamily: "sfpromedium", fontSize: "16px", }}>Languages</p>
                <p className="value" style={{ fontFamily: "sfproregular", fontSize: "16px", paddingTop: '10px' }}>English</p>

              </div>
              <div style={{ paddingTop: "20px" }}>
                <p className="title" style={{ fontFamily: "sfpromedium", fontSize: "16px" }}>Categories</p>
                <p className="value" style={{ fontFamily: "sfproregular", fontSize: "16px", paddingTop: '10px' }}>
                  {appData.list_of_categories.map(category => capitalizeFirstLetter(category.name)).join(', ')}
                </p>
              </div>



            </div>
          </>
        )}
      </div>




    </>
  );
};

AboutThisApp.propTypes = {
  appData: PropTypes.shape({
    status: PropTypes.string.isRequired,
    app_id: PropTypes.string.isRequired,
    app_name: PropTypes.string.isRequired,
    app_icon: PropTypes.string.isRequired,
    created_at: PropTypes.string, // Optional, adjust the type accordingly
    list_of_categories: PropTypes.arrayOf(PropTypes.any), // Optional, adjust the type accordingly
    // Add other required properties here
  }).isRequired,
};

export default AboutThisApp;
